import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject, Input,
  Optional,
} from "@angular/core";
import {DateControllerStateDirective} from "../../directives";
import {takeUntil} from "rxjs/operators";
import {DestroyStreamService} from "../../../../../services";
import {intChevronLeft, intChevronRight} from "../../../../../assets";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'int-year-selector',
  templateUrl: './int-year-selector.component.html',
  styleUrls: ['./int-year-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DestroyStreamService
  ]
})
export class IntYearSelectorComponent {
  date: Date = new Date();
  year: number | null = null;
  years: Array<number> = [];

  @Input() showNavigations = false;

  showList = false;

  constructor(
    private readonly destroy$: DestroyStreamService,
    @Optional()
    @Inject(DateControllerStateDirective) private readonly controller: DateControllerStateDirective,
    private readonly cdr: ChangeDetectorRef,
    private readonly sanitizer: DomSanitizer
  ) {

    if(!this.controller) {
      console.warn('Please provide intDateStateController [use DateControllerStateDirective]')
    }

    this.controller && this.controller.changePluginState$
      .pipe(
        takeUntil(this.destroy$)
      ).subscribe((date) => {
        this.date = date;
        this.update();
        this.cdr.markForCheck();
      });

    this.years = Array.from(Array(151)).map((_, id) => {
      return id + 1930;
    })
  }

  getPrevIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(intChevronLeft);
  }

  getNextIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(intChevronRight);
  }

  isSelected(year: number) {
    return this.predicate(year);
  }

  predicate(year: number): boolean {
    return year === this.controller.pluginDateStateForNavigation.year;
  }

  onSelectHandler(year: number) {
    this.controller.setPluginYear(year)
    this.toggleList();
  }

  toggleList() {
    this.showList = !this.showList;
  }

  update() {
    this.year = this.date.getFullYear();
  }

  next() {
    const {year} = this.controller.pluginDateStateForNavigation;
    this.controller.setPluginDate(year + 1);
  }

  prev() {
    const {year} = this.controller.pluginDateStateForNavigation;
    this.controller.setPluginDate(year - 1);
  }
}
